import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NoteService } from 'src/app/services/note.service';
import { Note } from 'src/app/shared/models/note/note';

@Component({
  selector: 'app-create-note',
  templateUrl: './create-note.component.html',
  styleUrls: ['./create-note.component.scss'],
})
export class CreateNoteComponent implements OnInit {
  @Input() clientId: number;
  @Input() createdByUserId: number;
  @Input() isWealth: boolean = false;
  @Output() noteCreateError = new EventEmitter<any>();
  @Output() noteCreated = new EventEmitter<Note>();
  noteText: string;
  noteSaving = false;

  constructor(private noteService: NoteService) {}

  ngOnInit(): void {}

  onSubmit(noteForm: NgForm) {
    if (noteForm.invalid) {
      noteForm.form.markAllAsTouched();
      return;
    }
    this.SaveClientNote(noteForm);
  }

  SaveClientNote(noteForm: NgForm) {
    this.noteSaving = true;
    this.noteService.CreateClientNote(this.clientId, this.createdByUserId, this.noteText, this.isWealth).subscribe({
      next: (newNote: Note) => {
        this.noteCreated.emit(newNote);
        this.noteText = '';
        noteForm.resetForm();
      },
      error: (error) => {
        //emit error for handling by the parent
        this.noteSaving = false;
        this.noteCreateError.emit(error);
      },
      complete: () => {
        // TODO: Figure out why this doesn't run on error
        this.noteSaving = false;
      },
    });
  }
}
